import React, { useState } from "react";
import Button from "../UI/Button";
import { useNavigate } from "react-router-dom";

const ImportInstrument = () => {
  const navigate = useNavigate();
  const validExchanges = [
    "CDS",
    "DGCX",
    "COMEX",
    "NSE",
    "NFO",
    "SGX",
    "BFO",
    "MCX",
    "BSE",
    "NSE-OPT",
    "NCDEX",
    "MCX-OPT",
    "NSE-DOTNET",
    "SPOT",
  ];

  const [selectedExchange, setSelectedExchange] = useState("");

  const onHandleShow = () => {
    if (selectedExchange) {
      navigate("/import/filter", {
        state: { exchange: selectedExchange }, // passing state
      });
    }
  };

  return (
    <div className="card_bod">
      <label htmlFor="exchange" className="block mb-2 font-medium">
        Select Exchange:
      </label>
      <select
        id="exchange"
        value={selectedExchange}
        onChange={(e) => setSelectedExchange(e.target.value)}
        className="border rounded p-2 w-64"
      >
        <option value="">-- Choose Exchange --</option>
        {validExchanges.map((exchange) => (
          <option key={exchange} value={exchange}>
            {exchange}
          </option>
        ))}
      </select>
      <div className="btn_box">
        <Button className={"btn-primary "} onClick={onHandleShow}>
          {"Show"}
        </Button>
        <Button className={"btn-danger"}>Cancel</Button>
      </div>
    </div>
  );
};

export default ImportInstrument;
